import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayTags'
})
export class DisplayTagsPipe implements PipeTransform {

  transform(value: any): any {
    if (value && value?.length > 0) {
      return value?.map(tag => ' ' + tag?.name);
    }
    return null;
  }

}
